import RequestAbstract from "../abstract";

/**
 * Gateway rules: a gateway's payin / payout allowance rule, which core reads once
 * per create, before any wallet is chosen, to decide whether the gateway takes it
 * at all. A rule that does not compile for its kind, or reads a wallet, is refused
 * on save (422 `GATEWAY_RULE_INVALID: …`).
 */
export default class PublicGatewayRules extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-gateway-rules";
    }

    /**
     * Every variable a rule may read, for the editor's help, in wallet rules' shape
     * (`[{ name, type, kinds, source, failureSlot, dayRange, description }]`): the
     * create's own only, the same list the cabinet checks a rule's names against.
     */
    async variables() {
        return await this.loadWithAuth(`${this.link}/variables`, { method: 'GET' });
    }

}
